import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './pagenotfound/pagenotfound.component';
import { ProductPageComponent } from './producto/pages/product-page.component';
import { QueryProductPageComponent } from './producto/pages/query-product-page.component';
import { MostrarFormularioComponent } from './empresa/page/mostrar-formulario/mostrar-formulario.component';
import { EditProductComponent } from './producto/components/edit-product/edit-product.component';
import { LoadAndQueryReportPageComponent } from './reporte/pages/report-page.component';
import { LoadAndQueryDevPageComponent } from './novedades/pages/report-devoluciones-page.component';
import { PresentacionComponent } from './presentacion/components/presentation/presentacion.component';
import { EditPresentationComponent } from './presentacion/components/edit-presentation/edit-presentation.component';
import { AddPresentationComponent } from './presentacion/components/add-presentation/add-presentation.component';
import { HomeComponent } from './proyecto/home.component';
import { ReporteVentasComponent } from './reporte-ventas-individual/reporte-ventas.component';
import { EditEmpresaComponent } from './empresa/editar-empresa/edit-empresa/edit-empresa.component';
import { EditDireccionComponent } from './empresa/editar-empresa/edit-direccion/edit-direccion.component';
import { ReportFilterDateComponent } from './reporte-filtro-fecha/report-filter-date.component';
import { BusquedaUsuarioComponent } from './administrador/busqueda-usuario/busqueda-usuario.component';
import { RoleGuard } from './role.guard';
import { RepresentanteAgenteVigiladoComponent } from './representante-agente-vigilado/representante-agente-vigilado.component';
import { TablerosBiComponent } from './administrador/tableros-bi/tableros-bi.component';
import { RepresentanteUsuarioComponent } from './representante-agente-vigilado/representante-usuario/editar.representante-usuario';
import { CargaEmpresasComponent } from './carga-empresas/carga-empresas.component';
import { CargaMasivaProductosComponent } from './carga-masiva-productos/carga-masiva-productos.component';
import { ReportFilterSemesterDevComponent } from './novedad-filtro-semestre/report-filter-semester-dev.component';
import { ParametrosComponent } from './administrador/parametros/parametros.component';
import { ComercializadorComponent } from './empresa/comercializador/comercializador.component';
import { BusquedaEmpresaComponent } from './administrador/busqueda-empresa/busqueda-empresa.component';
import { RegistroProductosComercializadoresComponent } from './productos-comercializadores/registro-productos-comercializadores/page/registro-productos-comercializadores.component';
import { ConsultarProductosComercializadoresComponent } from './productos-comercializadores/consultar-productos-comercializadores/page/consultar-productos-comercializadores.component';
import { ReporteVentasComercializadores } from './reporte-ventas-masivo-comercializador/reporte-ventas-comercializadores/page/reporte-ventas-comercializadores.component';
import { ClasificacionComercializadorComponent } from './empresa/comercializador/clasificacion-comercializador/clasificacion-comercializador.component';
import { ReporteManualComercializadorComponent } from './reporte-ventas-masivo-comercializador/reporte-manual-comercializador/reporte-manual-comercializador.component';
import { ReporteFiltroPeriodoComponent } from './reporte-ventas-masivo-comercializador/reporte-filtro-periodo/reporte-filtro-periodo.component';
import { ReporteCumplimientoProductorComponent } from './reporte-cumplimiento-productor/reporte-cumplimiento-productor.component';
import { CargaReportesMadrComponent } from './administrador/carga-reportes-madr/carga-reportes-madr.component';
import { ConsultaReportesMadrComponent } from './administrador/consulta-reportes-madr/consulta-reportes-madr.component';
import { EditaMasivaProductosComponent } from './administrador/edita-masiva-productos/edita-masiva-productos.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'consultar',
        component: QueryProductPageComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'nuevo-producto',
        component: ProductPageComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'carga-consulta-reportes',
        component: LoadAndQueryReportPageComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'carga-consulta-novedades',
        component: LoadAndQueryDevPageComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'nueva-empresa',
        component: MostrarFormularioComponent,
    },
    {
        path: 'editar-empresa',
        component: EditEmpresaComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'editar-empresa/:id',
        component: EditEmpresaComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
        },
    },
    {
        path: 'editar-direccion/:id',
        component: EditDireccionComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
        },
    },
    {
        path: 'editar-direccion',
        component: EditDireccionComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'editar-producto/:id',
        component: EditProductComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: ':id-producto/presentaciones',
        component: PresentacionComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: ':id-producto/presentaciones/agregar',
        component: AddPresentationComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: ':id-product/presentaciones/:id-pre',
        component: EditPresentationComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'inicio',
        component: HomeComponent,
    },
    {
        path: 'reporte-ventas',
        component: ReporteVentasComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'reporte-ventas/:id',
        component: ReporteVentasComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'reporte-filtro-fecha',
        component: ReportFilterDateComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'reporte-periodo-comercializador',
        component: ReporteFiltroPeriodoComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'novedad-filtro-fecha',
        component: ReportFilterSemesterDevComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'busqueda-user',
        component: BusquedaUsuarioComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: [
                'consultar_usuarios_empresa',
                'consultar_usuarios_upra',
            ],
        },
    },
    {
        path: 'busqueda-agente-vigilado',
        component: BusquedaEmpresaComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: ['consultar_empresas_admin_empresa'],
        },
    },
    {
        path: 'parametros',
        component: ParametrosComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: ['consultar_parametros'],
        },
    },
    {
        path: 'editar-user/:id',
        component: RepresentanteAgenteVigiladoComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
        },
    },
    {
        path: 'editar-user',
        component: RepresentanteUsuarioComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'tableros-bi',
        component: TablerosBiComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: ['consultar_tableros'],
        },
    },
    {
        path: 'cargar-empresas',
        component: CargaEmpresasComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'carga-masiva-productos',
        component: CargaMasivaProductosComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'registro-productos-comercializadores',
        component: RegistroProductosComercializadoresComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'comercializador',
        component: ComercializadorComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: ['AgenteVigilado'] },
    },
    {
        path: 'consultar-productos-comercializadores',
        component: ConsultarProductosComercializadoresComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    {
        path: 'reportes-ventas-comercializador',
        component: ReporteVentasComercializadores,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['AgenteVigilado'],
        },
    },
    //Se oculta la ruta para acceder a carga individual de comercializadores
    // {
    //     path: 'reporte-manual-comercializador',
    //     component: ReporteManualComercializadorComponent,
    //     canActivate: [RoleGuard],
    //     data: {
    //         expectedRoles: ['AgenteVigilado'],
    //     },
    // },
    {
        path: 'clasificacion-comercializador',
        component: ClasificacionComercializadorComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: ['clasificacion_comercializadores'],
        },
    },
    {
        path: 'reporte-cumplimiento-productor',
        component: ReporteCumplimientoProductorComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: ['Administrador (UPRA)'],
            expectedPermissions: [
                'realizar_seguimiento_de_cumplimiento_empresas_productor',
                'realizar_seguimiento_de_cumplimiento_empresas_comercializador',
            ],
        },
    },
    {
        path: 'edita-masiva-productos',
        component: EditaMasivaProductosComponent,
        canActivate: [RoleGuard],
        data: {
            expectedRoles: [
                'Administrador (UPRA)',
                'SuperAdministrador',
                'Usuarios UPRA - Analista',
            ],
            expectedPermissions: ['editar_productos_masivamente'],
        },
    },
    {
        path: 'carga-reportes-madr',
        component: CargaReportesMadrComponent,
        canActivate: [RoleGuard],
        data: {
            expectedPermissions: ['consultar_reportes_a_cargar_madr'],
        },
    },
    {
        path: 'consulta-reportes-madr',
        component: ConsultaReportesMadrComponent,
        canActivate: [RoleGuard],
        data: {
            expectedPermissions: ['consultar_reportes_madr'],
        },
    },
    {
        path: '**',
        component: PageNotFoundComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
